import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from "react";

//import general components
import BaseTabs from "../../../components/common/base-tabs/base-tabs";

//import view components
import AutoBooking from "../../../components/view/user-panel/smart-reservation/auto-booking";
import NotifyMe from "../../../components/view/user-panel/smart-reservation/notify-me";

import "./smart-reservation.scss";

export default function SmartReservation() {
    const { t } = useTranslation();

    //handle tab change
    const [activeTab, setActiveTab] = useState({
        notifyMe: true,
        autoBooking: false,
    });

    const handleTabChange = type => {
        setActiveTab({ [type]: true });
    };

    //list of tabs
    const tabList = [
        { type: "notifyMe", title: t("User Panel.notifyMe"), activeTab: activeTab.notifyMe, icon: "Bell" },
        { type: "autoBooking", title: t("User Panel.autoBooking"), activeTab: activeTab.autoBooking, icon: "Flash" },
    ];

    sessionStorage.removeItem("selectedFlight");
    sessionStorage.removeItem("selectedIntFlight");
    sessionStorage.removeItem("selectedReservation");

    return (
        <Grid className="smart-reservation" container item xs={12} rowGap={2} mb={5}>
            <Grid className="smart-reservation__box" container item xs={12} md={4} rowGap={2} justifyContent="center" mt={{ xs: 4, md: 0 }}>
                <BaseTabs handleTabChange={handleTabChange} list={tabList} style={{ top: "3rem", justifyContent: "space-evenly" }} />
            </Grid>

            {activeTab.notifyMe && <NotifyMe />}
            {activeTab.autoBooking && <AutoBooking />}
        </Grid>
    );
}
